import { defineMessages } from 'react-intl';

export default defineMessages({
    applicationInfo: {
        id: '_.navigation.application_info',
        defaultMessage: "You're applying for {requestedAmount}"
    },
    applicationInfoMobile: {
        id: '_.navigation.application_info_mobile',
        defaultMessage: "You're applying for {requestedAmount}"
    }
});
